import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TPrCalendarDM from './TPrCalendarDM'
import TBookDM from './TBookDM'
import TTextDM from './TTextDM'
import TCode6DocumentDM from './TCode6DocumentDM'
import TCode5DocumentDM from './TCode5DocumentDM'
import TCode4DocumentDM from './TCode4DocumentDM'
import TCode3DocumentDM from './TCode3DocumentDM'
import TOrgStrTreeUnitDM from './TOrgStrTreeUnitDM'
import TK2UserLookupDM from './TK2UserLookupDM'
import TArticleCodeDocumentDM from './TArticleCodeDocumentDM'
import TCostCentreCollectionDocumentDM from './TCostCentreCollectionDocumentDM'
import DegreeName from './DegreeName'
import CZNACE from './CZNACE'
import TDeviceDocumentDM from './TDeviceDocumentDM'
import TOrgStrJobDM from './TOrgStrJobDM'
import TPrDeductionDM from './TPrDeductionDM'
import TContractCodeDocumentDM from './TContractCodeDocumentDM'
import TCurrencyDM from './TCurrencyDM'
import TAccountingChartDM from './TAccountingChartDM'
import DuvUkoncPP2 from './DuvUkoncPP2'
import TCountryDM from './TCountryDM'
import SkupPrac from './SkupPrac'
import MzdZUJ from './MzdZUJ'
import CZICSE from './CZICSE'
import TTownPartDM from './TTownPartDM'
import ProfessionName from './ProfessionName'
import MzdLAU1 from './MzdLAU1'
import NUTS4 from './NUTS4'
import TMatchingSymbolDM from './TMatchingSymbolDM'
import TCode2DocumentDM from './TCode2DocumentDM'
import TCode1DocumentDM from './TCode1DocumentDM'
import Group2 from './Group2'
import Group1 from './Group1'
import Kategorie2 from './Kategorie2'
import Kategorie1 from './Kategorie1'
import TPrUnionDM from './TPrUnionDM'
import TPrMinimalTariffDM from './TPrMinimalTariffDM'
import TPrInternalTariffDM from './TPrInternalTariffDM'
import EmployeeFunction from './EmployeeFunction'
import DruhCinnosti from './DruhCinnosti'
import RelWork from './RelWork'
import TypWork from './TypWork'
import DuvUkoncPP1 from './DuvUkoncPP1'
import DuvVznikuPP1 from './DuvVznikuPP1'
import TEmployedPersonSimpleDM from './TEmployedPersonSimpleDM'
import TPrPeriodDM from './TPrPeriodDM'
import TPrTariffDM from './TPrTariffDM'
import PrempReasons from './PrempReasons'
import PrEmpWorksCatalog from './PrEmpWorksCatalog'
import TMarketingActivityTypeDM from './TMarketingActivityTypeDM'
import TWorkflowProcessDM from './TWorkflowProcessDM'
import TCommentDM from './TCommentDM'
import TWorkflowProcessAsItemDM from './TWorkflowProcessAsItemDM'
import TLanguageMemoTranslationDM from './TLanguageMemoTranslationDM'
import TAttachedDocumentDM from './TAttachedDocumentDM'
import TOldNoteDM from './TOldNoteDM'

export default class TPrEmploymentSimpleDM extends Data {
	public static className = 'TPrEmploymentSimpleDM'
	public static primaryKey = 'Id'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	SocialInsuranceIdentifier?: string
	NotCopyAnalyticalDimensions?: string
	FirstName?: string
	Surname?: string
	EmployeePersonNumber?: string
	Abbr?: string
	CreatedOn?: Date
	IsShortRangeEmployment?: string
	IsExecutive?: string
	IsImmediateStart?: string
	IsExemption?: string
	IsInCurrency?: string
	IsNoPaidOverTime?: string
	IsAdditionalLeave?: string
	IsExtendedLeave?: string
	IsNormalLeave?: string
	CalculateWageAutomatically?: string
	CheckMinWage?: string
	XMLFieldScript?: string
	IsInvalidRecord?: string
	IsFirstEmploymentInCZ?: string
	ChangeContractDate?: Date
	SignatureDate?: Date
	ProbationaryPeriodMonthCount?: number
	WorkPlaceId?: string
	ExpectedTerminationDate?: Date
	NoticePeriodFrom?: Date
	ProbationaryPeriodEndDate?: Date
	RedundancyPaymentMultiple?: number
	RightGroupId?: number
	ChangedOn?: Date
	Automat4PrComponentId?: number
	Automat3PrComponentId?: number
	Automat2PrComponentId?: number
	Automat1PrComponentId?: number
	AdvanceWagePayment?: number
	WageBonus?: number
	WagePersonalBonus2?: number
	WagePersonalBonus?: number
	BasicWage2?: number
	BasicWage?: number
	ContractDate?: Date
	TerminationDate?: Date
	EntryDate?: Date
	CompanyId?: number
	TimeStamp?: string
	XMLField?: string
	SequenceNumber?: number
	Id?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	SQLSequenceOrderCalc?: number
	IsItemCompleteCalc?: string
	ProbationaryPeriodInDaysCalc?: number
	EmploymentDayCountCalc?: number
	IsMainEmploymentCalc?: string
	LegalRelationDescriptionCalc?: string
	IsEmploymentValidityDateCalc?: string
	DifficultEnvironmentCalc?: string
	AllowSickDaysCalc?: string
	PersonalBonusAmountCalc?: number
	ExtraBonusCalc?: number
	ManagementBonusAmountCalc?: number
	IsExceptionallyGradeSetCalc?: string
	IsSpecialLevelSetCalc?: string
	IsLeadingPositionCalc?: string
	DifficultEnvironmentRateCalc?: number
	DateFrom?: Date
	DateTo?: Date
	PrEmploymentId?: number
	LegalRelationSequenceDescriptionCalc?: string
	ActivationDateCalc?: Date
	ContactPersonIdCalc?: number
	AgreedWorkloadWeekCalc?: number
	AgreedWorkloadDayCalc?: number
	StatedWorkloadWeekCalc?: number
	StatedWorkloadDayCalc?: number
	ShortenedWorkTimeCalc?: string
	ShortenedWorkTimePctCalc?: number
	ShortenedWorkTimeRatioCalc?: number
	TextHeaderMemoCalc?: string
	TextFooterMemoCalc?: string
	LastCommentParamCalc?: string
	RightGroupIdCalc?: number
	@Type(() => TPrCalendarDM)
	AdditionalCalendarId?: TPrCalendarDM
	@Type(() => TBookDM)
	AttendanceBookId?: TBookDM
	@Type(() => TTextDM)
	RedundancyPaymentParagraphId?: TTextDM
	@Type(() => TCode6DocumentDM)
	Code6Id?: TCode6DocumentDM
	@Type(() => TCode5DocumentDM)
	Code5Id?: TCode5DocumentDM
	@Type(() => TCode4DocumentDM)
	Code4Id?: TCode4DocumentDM
	@Type(() => TCode3DocumentDM)
	Code3Id?: TCode3DocumentDM
	@Type(() => TOrgStrTreeUnitDM)
	OrgStrTreeUnitRID?: TOrgStrTreeUnitDM
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM
	@Type(() => TArticleCodeDocumentDM)
	ArticleCodeId?: TArticleCodeDocumentDM
	@Type(() => TCostCentreCollectionDocumentDM)
	CostCentre2Id?: TCostCentreCollectionDocumentDM
	@Type(() => TCostCentreCollectionDocumentDM)
	CostCentre1Id?: TCostCentreCollectionDocumentDM
	@Type(() => TBookDM)
	BookId?: TBookDM
	@Type(() => DegreeName)
	RequiredEducationLevelId?: DegreeName
	@Type(() => CZNACE)
	CZNACEId?: CZNACE
	@Type(() => TDeviceDocumentDM)
	DeviceRID?: TDeviceDocumentDM
	@Type(() => TOrgStrJobDM)
	OrgStrJobRID?: TOrgStrJobDM
	@Type(() => TPrDeductionDM)
	WageDeductionId?: TPrDeductionDM
	@Type(() => TContractCodeDocumentDM)
	ContractCodeRID?: TContractCodeDocumentDM
	@Type(() => TCurrencyDM)
	Currency?: TCurrencyDM
	@Type(() => TPrDeductionDM)
	TaxOfficeId?: TPrDeductionDM
	@Type(() => TPrCalendarDM)
	WorkFundCalendarId?: TPrCalendarDM
	@Type(() => TAccountingChartDM)
	HealthInsuranceAccountId?: TAccountingChartDM
	@Type(() => TAccountingChartDM)
	SocialSecurityAccountId?: TAccountingChartDM
	@Type(() => DuvUkoncPP2)
	AditionalTerminationReasonId?: DuvUkoncPP2
	@Type(() => TCountryDM)
	WorkCountryId?: TCountryDM
	@Type(() => SkupPrac)
	GroupId?: SkupPrac
	@Type(() => MzdZUJ)
	AdministrativeDivisionId?: MzdZUJ
	@Type(() => CZICSE)
	CZICSEId?: CZICSE
	@Type(() => TTownPartDM)
	WorkTownPartId?: TTownPartDM
	@Type(() => TCostCentreCollectionDocumentDM)
	PayrollCentreId?: TCostCentreCollectionDocumentDM
	@Type(() => ProfessionName)
	CZISCOId?: ProfessionName
	@Type(() => MzdLAU1)
	LAU1Id?: MzdLAU1
	@Type(() => NUTS4)
	NUTS4Id?: NUTS4
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TAccountingChartDM)
	DebitAccountId?: TAccountingChartDM
	@Type(() => TAccountingChartDM)
	CreditAccountId?: TAccountingChartDM
	@Type(() => TMatchingSymbolDM)
	MatchingSymbolId?: TMatchingSymbolDM
	@Type(() => TCode2DocumentDM)
	Code2Id?: TCode2DocumentDM
	@Type(() => TCode1DocumentDM)
	Code1Id?: TCode1DocumentDM
	@Type(() => Group2)
	Group2Id?: Group2
	@Type(() => Group1)
	Group1Id?: Group1
	@Type(() => Kategorie2)
	Category2Id?: Kategorie2
	@Type(() => Kategorie1)
	Category1Id?: Kategorie1
	@Type(() => TTextDM)
	SocialActivityTypeId?: TTextDM
	@Type(() => TTextDM)
	TaxDeductionTypeId?: TTextDM
	@Type(() => TTextDM)
	DeductionSocialSecurityId?: TTextDM
	@Type(() => TTextDM)
	DeductionHealthInsuranceId?: TTextDM
	@Type(() => TTextDM)
	TaxPayerTypeId?: TTextDM
	@Type(() => TPrUnionDM)
	UnionId?: TPrUnionDM
	@Type(() => TTextDM)
	WageTypeId?: TTextDM
	@Type(() => TPrMinimalTariffDM)
	GuaranteedWage?: TPrMinimalTariffDM
	@Type(() => TPrInternalTariffDM)
	InternalTariffId?: TPrInternalTariffDM
	@Type(() => TPrCalendarDM)
	LegalCalendarId?: TPrCalendarDM
	@Type(() => TPrCalendarDM)
	WorkShiftCalendarId?: TPrCalendarDM
	@Type(() => EmployeeFunction)
	JobClassificationId?: EmployeeFunction
	@Type(() => TTextDM)
	DurationTypeId?: TTextDM
	@Type(() => DruhCinnosti)
	EmploymentTypeId?: DruhCinnosti
	@Type(() => TTextDM)
	LegalRelationId?: TTextDM
	@Type(() => RelWork)
	LegalSubrelation2Id?: RelWork
	@Type(() => TTextDM)
	LegalSubrelation1Id?: TTextDM
	@Type(() => TypWork)
	WorkTypeId?: TypWork
	@Type(() => DuvUkoncPP1)
	TerminationReasonId?: DuvUkoncPP1
	@Type(() => DuvVznikuPP1)
	CommencementReasonId?: DuvVznikuPP1
	@Type(() => TEmployedPersonSimpleDM)
	EmployedPersonId?: TEmployedPersonSimpleDM
	@Type(() => TTextDM)
	InvalidRecordImgCalc?: TTextDM
	@Type(() => TPrPeriodDM)
	ProcessPeriodIdCalc?: TPrPeriodDM
	@Type(() => TCurrencyDM)
	CurrencyCalc?: TCurrencyDM
	@Type(() => TCurrencyDM)
	ClientCurrencyCalc?: TCurrencyDM
	@Type(() => TTextDM)
	EmploymentValidityBitCalc?: TTextDM
	@Type(() => TBookDM)
	PrDocumentBookIdCalc?: TBookDM
	@Type(() => TTextDM)
	EmploymentValidityOFBitCalc?: TTextDM
	@Type(() => TTextDM)
	EmploymentValidityDateCalc?: TTextDM
	@Type(() => TPrPeriodDM)
	UserPeriodIdCalc?: TPrPeriodDM
	@Type(() => TPrPeriodDM)
	PeriodToIdCalc?: TPrPeriodDM
	@Type(() => TPrPeriodDM)
	LastPeriodIdCalc?: TPrPeriodDM
	@Type(() => TPrTariffDM)
	PayrollTariffRIDCalc?: TPrTariffDM
	@Type(() => TTextDM)
	GradeIdCalc?: TTextDM
	@Type(() => TTextDM)
	LevelIdCalc?: TTextDM
	@Type(() => PrempReasons)
	PersonalBonusReasonIdCalc?: PrempReasons
	@Type(() => PrempReasons)
	ExtraBonusReasonIdCalc?: PrempReasons
	@Type(() => PrempReasons)
	ManagementBonusReasonIdCalc?: PrempReasons
	@Type(() => TTextDM)
	ManagementLevelIdCalc?: TTextDM
	@Type(() => TTextDM)
	ExtraBonusGroupIdCalc?: TTextDM
	@Type(() => PrempReasons)
	DifficultEnvironmentRateReasonCalc?: PrempReasons
	@Type(() => PrEmpWorksCatalog)
	WorksCatalogIdCalc?: PrEmpWorksCatalog
	@Type(() => TPrPeriodDM)
	ProcessedPeriodIdCalc?: TPrPeriodDM
	@Type(() => TTextDM)
	DocumentExistsCalc?: TTextDM
	@Type(() => TMarketingActivityTypeDM)
	ActivityTypeRIDCalc?: TMarketingActivityTypeDM
	@Type(() => TTextDM)
	ProcessStateIdCalc?: TTextDM
	@Type(() => TWorkflowProcessDM)
	CurrentProcessIdCalc?: TWorkflowProcessDM
	@Type(() => TCommentDM)
	CommentChild?: TCommentDM[]
	@Type(() => TWorkflowProcessAsItemDM)
	WorkflowProcessChild?: TWorkflowProcessAsItemDM[]
	@Type(() => TLanguageMemoTranslationDM)
	TextHeaderChild?: TLanguageMemoTranslationDM[]
	@Type(() => TLanguageMemoTranslationDM)
	TextFooterChild?: TLanguageMemoTranslationDM[]
	@Type(() => TAttachedDocumentDM)
	AttachedDocumentOldChild?: TAttachedDocumentDM[]
	@Type(() => TOldNoteDM)
	DeprecatedNoteOldChild?: TOldNoteDM[]
}